import { render, staticRenderFns } from "./Pair.vue?vue&type=template&id=23396942&scoped=true"
import script from "./Pair.vue?vue&type=script&lang=js"
export * from "./Pair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23396942",
  null
  
)

export default component.exports